import { useContext, createContext } from "react";

export const FiltersContext = createContext({
  change: (value) => null,
});

export const useFilters = () => useContext(FiltersContext);
